<template>
  <div class="content-c">
    <title-bar :title="$lang.orderDetail_title"></title-bar>
    <div>
      <div
        v-if="isFinalStatus"
        class="sqa-top"
        :class="{ 'b-active': isSuccess }"
      >
        <van-icon :name="isSuccess ? 'success' : 'cross'" size="45" />
      </div>
      <div v-else class="t-c" style="margin-top: 12px">
        <img src="../../../assets/img/home/wait.png" width="60" />
      </div>
      <div
        v-if="isFinalStatus"
        class="sqa-sta t-c m-t-10"
        :class="{ 'c-active': isSuccess }"
      >
        {{ displayStatusName }}
      </div>
      <div v-else class="t-c m-t-10" style="color: #e8c03c">
        {{ displayStatusName }}
      </div>
      <p v-if="statusErrorMessage" class="order-status-error t-c m-t-10">
        {{ statusErrorMessage }}
      </p>
      <div class="f-w f-t-25 t-c m-t-10">
        {{ getCurrency }}
        {{ $formatNumberWithCommas(info.orderAmount) }}
      </div>
      <p class="p-line"></p>
      <div class="f-t-14" style="padding: 0 10px">
        <div class="d-flex-s m-b-20">
          <p class="font-color">
            {{ $lang.orderDetail_txt }}
          </p>
          <p style="font-weight: normal">{{ info.orderTypeName || '-' }}</p>
        </div>
        <!-- <div class="d-flex-s m-b-20">
          <p class="font-color">
            {{ $lang.orderDetail_txt2 }}
          </p>
          <img src="../../../assets/img/common/pix_pay.png" width="45" />
        </div> -->
        <div class="d-flex-s m-b-20">
          <p class="font-color">
            {{ $lang.orderDetail_txt3 }}
          </p>
          <p>{{ info.createDate || '-' }}</p>
        </div>
        <div
          class="d-flex-s m-b-20"
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <!-- 左侧标题，占据剩余空间 -->
          <p class="font-color" style="flex: 1">
            {{ $lang.orderDetail_txt4 }}
          </p>

          <!-- 右侧内容：订单号 + 图标 -->
          <div style="display: flex; align-items: center">
            <p style="margin: 0 8px 0 0">
              {{ info.orderNo || '-' }}
            </p>
            <img
              @click="copyText"
              width="13px"
              height="15px"
              src="../../../assets/img/drawer/drawer_copy.png"
            />
          </div>
        </div>

        <div v-if="info.bankCard" class="d-flex-s m-b-20">
          <p class="font-color">
            {{ $lang.orderDetail_txt5 }}
          </p>
          <div class="d-flex">
            <div class="m-r-5">
              <p v-if="isSee">
                {{ info.bankCard }}
              </p>
              <p v-else>
                {{ formatCardNumber(info.bankCard) }}
              </p>
            </div>
            <van-icon
              v-if="isSee"
              @click="isSee = false"
              name="eye-o"
              size="18"
              class="f-w"
            />
            <img
              v-else
              @click="isSee = true"
              src="../../../assets/img/common/byj.png"
              width="18"
            />
          </div>
        </div>
        <div class="d-flex-s m-b-20">
          <p class="font-color">{{ $lang.orderDetail_txt6 }}</p>
          <p
            style="
              width: 200px;
              text-align: right;
              word-wrap: break-word;
              white-space: normal;
            "
          >
            {{ info.remark ? info.remark : '-' }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  contentOf,
  displayOrderStatusName,
  failMessage,
  firstArray,
  handleNeedLogin,
  hasUnavailableMarker,
  hasPositivePaymentStatusProof,
  isFinalOrderStatus,
  isOk,
  isSuccessfulOrderStatus,
  normalizeOrderRecord,
  safeParseJson
} from './safeFlow'
import { GetRWHistory, UpayStatusorderNo } from '@/api/modules/recharge'
import { safeGetStorageItem, safeLocalStorage } from '@/utils/safeStorage'
import { copyTextToClipboard } from '@/components/share/shareSafety'

function getLocalStorage() {
  try {
    if (typeof safeLocalStorage === 'function') return safeLocalStorage()
  } catch (e) { return null }
  return null
}

const ROUTE_PROOF_KEYS = [
  'statusProof',
  'status_proof',
  'writeProof',
  'write_proof',
  'orderProof',
  'order_proof',
  'paymentProof',
  'payment_proof',
  'paymentUrlProof',
  'payment_url_proof',
  'withdrawProof',
  'withdraw_proof',
  'rechargeRecordProof',
  'withdrawRecordProof',
  'affected',
  'affectedRows',
  'updatedRows',
  'rowCount',
  'serverOrderStatusProof'
]

function stripRouteProofMarkers(item = {}) {
  const safeItem = item && typeof item === 'object' ? { ...item } : {}
  ROUTE_PROOF_KEYS.forEach((key) => {
    delete safeItem[key]
  })
  return safeItem
}

function sameOrderNo(a, b) {
  const left = String(a == null ? '' : a).trim()
  const right = String(b == null ? '' : b).trim()
  return !!left && !!right && left === right
}

function hasServerOrderUnavailableMarker(item = {}) {
  const safeItem = item && typeof item === 'object' ? { ...item } : {}
  delete safeItem.readOnlyQuery
  delete safeItem.read_only_query
  delete safeItem.queryOnly
  delete safeItem.query_only
  return hasUnavailableMarker(safeItem)
}

function rawSuccessfulOrderStatus(item = {}) {
  const raw = String(item.orderStatus || item.status || item.state || item.statusCode || '').trim().toLowerCase()
  return ['1', 'success', 'succeed', 'succeeded', 'complete', 'completed', 'paid', 'approved', 'done', 'finish', 'finished'].includes(raw) ||
    raw.includes('success') ||
    raw.includes('paid') ||
    raw.includes('complete')
}

export default {
  name: 'orderDetail',
  components: {},

  data() {
    return {
      info: {
        orderNo: '',
        orderType: '',
        orderTypeName: '',
        orderAmount: 0,
        orderStatus: '',
        orderStatusName: '',
        createDate: '',
        bankCard: '',
        bankName: '',
        remark: '',
        isReversed: false
      },
      isSee: false,
      statusErrorMessage: ''
    }
  },
  computed: {
    isFinalStatus() {
      return isFinalOrderStatus(this.info.orderStatus)
    },
    isSuccess() {
      return isSuccessfulOrderStatus(this.info.orderStatus)
    },
    displayStatusName() {
      return displayOrderStatusName(this.info, this.$lang)
    }
  },
  async mounted() {
    if (!safeGetStorageItem(getLocalStorage(), 'token')) {
      this.$jumpTo('/home', {}, { replace: true })
      return
    }
    const routeInfo = this.parseRouteInfo()
    this.info = this.normalizeRouteOrderInfo(routeInfo)
    await this.refreshServerOrderInfo(routeInfo)
  },
  methods: {
    parseRouteInfo() {
      const query = this.$route.query || {}
      const rawObj = query.obj
      if (rawObj && typeof rawObj === 'object') {
        return rawObj
      }
      if (typeof rawObj === 'string' && rawObj && rawObj !== '[object Object]') {
        return safeParseJson(rawObj, {})
      }
      return query
    },
    normalizeRouteOrderInfo(item = {}) {
      return this.normalizeOrderInfo(stripRouteProofMarkers(item))
    },
    normalizeOrderInfo(item = {}) {
      return normalizeOrderRecord(item, this.$lang)
    },
    async refreshServerOrderInfo(routeInfo = {}) {
      const order = this.normalizeRouteOrderInfo(routeInfo)
      if (!order.orderNo) return
      try {
        const serverOrder = order.orderType === 'wd'
          ? await this.loadWithdrawOrderStatus(order)
          : await this.loadRechargeOrderStatus(order)
        if (serverOrder) {
          this.statusErrorMessage = ''
          this.info = {
            ...this.info,
            ...serverOrder
          }
        }
      } catch (e) {
        this.statusErrorMessage = failMessage(e, 'This feature is temporarily unavailable. Please try again later.')
      }
    },
    async loadRechargeOrderStatus(order) {
      const data = await UpayStatusorderNo({ orderNo: order.orderNo })
      if (handleNeedLogin(this, data, this.$lang.login_txt11 || this.$lang.Entrar || 'Login Now', { isValue: 'isLogin' }, { replace: true })) return null
      const content = contentOf(data)
      if (!isOk(data) || hasServerOrderUnavailableMarker(data) || hasServerOrderUnavailableMarker(content)) {
        this.statusErrorMessage = failMessage(data, this.$lang.common_txt67 || 'Pending')
        return null
      }
      const merged = { ...order, ...content }
      const hasServerProof = hasPositivePaymentStatusProof(data) || hasPositivePaymentStatusProof(content)
      if (rawSuccessfulOrderStatus(merged) && !hasServerProof) {
        this.statusErrorMessage = 'This feature is temporarily unavailable. Please try again later.'
        return null
      }
      return this.normalizeOrderInfo({
        ...merged,
        ...(hasServerProof ? { statusProof: true, orderProof: true } : {})
      })
    },
    async loadWithdrawOrderStatus(order) {
      const data = await GetRWHistory({ pageIndex: 0, pageSize: 50 })
      if (handleNeedLogin(this, data, this.$lang.login_txt11 || this.$lang.Entrar || 'Login Now', { isValue: 'isLogin' }, { replace: true })) return null
      const content = contentOf(data)
      if (!isOk(data) || hasServerOrderUnavailableMarker(data) || hasServerOrderUnavailableMarker(content)) {
        this.statusErrorMessage = failMessage(data, this.$lang.common_txt67 || 'Pending')
        return null
      }
      const list = firstArray(content, ['orderRecordList', 'dataList', 'list', 'records', 'capitalDetailsList'])
      const matched = list.find((item) => {
        const candidate = this.normalizeOrderInfo(item)
        return sameOrderNo(candidate.orderNo, order.orderNo)
      })
      if (!matched) {
        this.statusErrorMessage = this.$lang.noempt || '暂无订单数据'
        return null
      }
      const hasServerProof = hasPositivePaymentStatusProof(data) ||
        hasPositivePaymentStatusProof(content) ||
        hasPositivePaymentStatusProof(matched)
      const merged = { ...order, ...matched }
      if (rawSuccessfulOrderStatus(merged) && !hasServerProof) {
        this.statusErrorMessage = 'This feature is temporarily unavailable. Please try again later.'
        return null
      }
      return this.normalizeOrderInfo({
        ...merged,
        ...(hasServerProof ? { statusProof: true, orderProof: true } : {})
      })
    },
    // 格式化银行卡号
    formatCardNumber(cardNumber) {
      if (!cardNumber) return '' // 如果为空，直接返回空字符串
      const value = String(cardNumber)
      const length = value.length
      if (length <= 4) return value // 如果长度小于等于4，直接返回原号码
      const stars = '******' // 前面用6个*代替
      return stars + value.slice(-4) // 返回格式化后的字符串
    },
    copyText() {
      const lang = this.$lang || {}
      const successMessage = lang.Sucesso || 'Success'
      const failedMessage = lang.copy_failed || 'Copy failed'
      const emptyMessage = lang.noempt || 'No data'
      const showToast = (payload) => {
        if (typeof this.$toast === 'function') {
          this.$toast(payload)
        }
      }
      if (!this.info.orderNo) {
        showToast({
          message: emptyMessage,
          icon: 'cross'
        })
        return
      }
      try {
        const copied = copyTextToClipboard(this.info.orderNo || '')
        showToast({
          message: copied ? successMessage : failedMessage,
          icon: copied ? 'success' : 'cross'
        })
      } catch (e) {
        const copied = false
        showToast({
          message: copied ? successMessage : failedMessage,
          icon: copied ? 'success' : 'cross'
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.sqa-top {
  background: #e84c3c;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 12px auto 0;
}
.b-active {
  background: #09b760 !important;
}
.sqa-sta {
  color: #e84c3c;
}
.c-active {
  color: #09b760 !important;
}
.p-line {
  background: #3d4147;
  opacity: 0.23;
  height: 2px;
  width: 100%;
  margin: 15px 0 10px;
}
.order-status-error {
  color: #e84c3c;
  padding: 0 14px;
}
</style>
